var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useContext } from 'react';
import { Pressable, View } from 'react-native';
import { CancelButtonIcon } from '../../icons';
import { StateConfigContext } from '../../providers';
import { getCurrentEventControlState, getTestId } from '../../utils';
import { DynamicSvg } from '../dynamic-svg';
import { Notifier } from '../notifier';
import { Typography } from '../typography';
import { getBadgeFontTypes, getBadgeProps, getBadgeStyles, getSelectedState } from './BadgeStyles';
export var Badge = forwardRef((props, ref) => {
  var _a, _b, _c, _d, _e, _f, _g, _h;
  var stateContext = useContext(StateConfigContext);
  var badgeProps = getBadgeProps(props, stateContext);
  var type = badgeProps.type,
    size = badgeProps.size,
    label = badgeProps.label,
    multitextLabel = badgeProps.multitextLabel,
    disabled = badgeProps.disabled,
    controlState = badgeProps.controlState,
    showPrefixIcon = badgeProps.showPrefixIcon,
    showPostfixIcon = badgeProps.showPostfixIcon,
    _badgeProps$prefixIco = badgeProps.prefixIconName,
    prefixIconName = _badgeProps$prefixIco === void 0 ? 'AddEnclosedIcon' : _badgeProps$prefixIco,
    _badgeProps$postfixIc = badgeProps.postfixIconName,
    postfixIconName = _badgeProps$postfixIc === void 0 ? 'AddEnclosedIcon' : _badgeProps$postfixIc,
    showNotifier = badgeProps.showNotifier,
    notifierNumber = badgeProps.notifierNumber,
    prefixIconProps = badgeProps.prefixIconProps,
    postfixIconProps = badgeProps.postfixIconProps,
    isSelected = badgeProps.isSelected,
    _badgeProps$postfixNo = badgeProps.postfixNotifierPosition,
    postfixNotifierPosition = _badgeProps$postfixNo === void 0 ? 'right' : _badgeProps$postfixNo,
    config = badgeProps.config,
    style = badgeProps.style,
    _badgeProps$testID = badgeProps.testID,
    testID = _badgeProps$testID === void 0 ? 'Badge' : _badgeProps$testID,
    restProps = __rest(badgeProps, ["type", "size", "label", "multitextLabel", "disabled", "controlState", "showPrefixIcon", "showPostfixIcon", "prefixIconName", "postfixIconName", "showNotifier", "notifierNumber", "prefixIconProps", "postfixIconProps", "isSelected", "postfixNotifierPosition", "config", "style", "testID"]);
  var badgeStyles = getBadgeStyles(badgeProps, controlState);
  var selectedState = getSelectedState(props === null || props === void 0 ? void 0 : props.isSelected, type);
  var controlStates = (_b = (_a = config === null || config === void 0 ? void 0 : config.states) === null || _a === void 0 ? void 0 : _a[selectedState]) === null || _b === void 0 ? void 0 : _b.controlStates;
  var isMultiSelected = type === 'multi' && isSelected;
  var getStyle = event => {
    var _state = getCurrentEventControlState(event, controlState);
    return getBadgeStyles(badgeProps, _state);
  };
  var getPressableStyle = event => {
    return [getStyle(event).container, style];
  };
  var iconProps = {
    width: (_d = (_c = config === null || config === void 0 ? void 0 : config.size) === null || _c === void 0 ? void 0 : _c[size]) === null || _d === void 0 ? void 0 : _d.iconSize,
    height: (_f = (_e = config === null || config === void 0 ? void 0 : config.size) === null || _e === void 0 ? void 0 : _e[size]) === null || _f === void 0 ? void 0 : _f.iconSize,
    style: {
      backgroundColor: (_g = controlStates === null || controlStates === void 0 ? void 0 : controlStates[controlState]) === null || _g === void 0 ? void 0 : _g.iconBgColor
    },
    color: (_h = controlStates === null || controlStates === void 0 ? void 0 : controlStates[controlState]) === null || _h === void 0 ? void 0 : _h.iconColor
  };
  var renderNotifier = () => showNotifier && controlState !== 'disabled' && _jsx(Notifier, {
    number: notifierNumber,
    size: size,
    style: badgeStyles === null || badgeStyles === void 0 ? void 0 : badgeStyles.marginLeft
  });
  var renderPostfixIcon = () => showPostfixIcon && !!postfixIconName && _jsx(View, Object.assign({
    style: badgeStyles === null || badgeStyles === void 0 ? void 0 : badgeStyles.marginLeft
  }, {
    children: _jsx(DynamicSvg, Object.assign({
      iconName: postfixIconName
    }, postfixIconProps, getTestId(testID, postfixIconName)))
  }));
  return _jsxs(Pressable, Object.assign({
    ref: ref,
    style: getPressableStyle
  }, restProps, {
    disabled: disabled || controlState == 'disabled'
  }, getTestId(testID), {
    children: [showPrefixIcon && !!prefixIconName && _jsx(View, Object.assign({
      style: badgeStyles === null || badgeStyles === void 0 ? void 0 : badgeStyles.prefixIconContainer
    }, {
      children: _jsx(DynamicSvg, Object.assign({
        iconName: prefixIconName
      }, prefixIconProps, getTestId(testID, prefixIconName)))
    })), _jsx(Typography, Object.assign({
      type: getBadgeFontTypes(size)
    }, label && {
      text: label
    }, multitextLabel && {
      multiText: multitextLabel
    }, {
      style: badgeStyles === null || badgeStyles === void 0 ? void 0 : badgeStyles.label
    }, getTestId(testID, 'label'))), postfixNotifierPosition === 'left' ? _jsxs(_Fragment, {
      children: [renderNotifier(), renderPostfixIcon()]
    }) : _jsxs(_Fragment, {
      children: [renderPostfixIcon(), renderNotifier()]
    }), isMultiSelected && _jsx(View, Object.assign({
      style: badgeStyles === null || badgeStyles === void 0 ? void 0 : badgeStyles.iconContainer
    }, {
      children: _jsx(CancelButtonIcon, Object.assign({}, iconProps, getTestId(testID, 'cancelButtonIcon')))
    }))]
  }));
});